export default "__VITE_ASSET__Bs4oKT1$__"